<h1>Nous contacter</h1>

<div class="container mb-5">
    <h2 class="text-center mb-3">Pour nous laisser un message, merci d'utiliser le formulaire suivant</h2>
    <form class="message-form" [formGroup]="messageForm" (ngSubmit)="onSubmitForm()">
        <div class="row">
            <div class="col-12 col-sm-6 mb-3 mb-sm-0">
                <input type="text" class="form-control" placeholder="Prénom" aria-label="First name"
                    formControlName="firstname"
                    (blur)="testNomPrenom()">
                <p class="text-danger d-none d-sm-block">{{ messageErreurPrenomNom }}</p>
            </div>
            <div class="col-12 col-sm-6 mb-3">
                <input type="text" class="form-control" placeholder="Nom" aria-label="Last name" 
                    formControlName="lastname"
                    (blur)="testNomPrenom()">
                <p class="text-danger d-sm-none">{{ messageErreurPrenomNom }}</p>
            </div>
        </div>
        <div class="row">
            <div class="col-12 mb-3">
                <input type="email" class="form-control" placeholder="email" aria-label="email"
                    formControlName="email"
                    (blur)="testEmail()">
                    <p class="text-danger">{{ messageErreurEmail }}</p>
            </div>
        </div>
        <div class="mb-3">
            <label for="exampleFormControlTextarea1" class="form-label">Votre message ici:</label>
            <textarea class="form-control" id="exampleFormControlTextarea1" rows="4"
                formControlName="message"
                (blur)="testMessageIsNotEmpty()">
            </textarea>
                <p class="text-danger">{{ messageErreurContent }}</p>
          </div>
        <button type="submit" class="btn" [disabled]="messageForm.invalid || !prenomNomIsValid">Envoyer message</button>
    </form>
</div>
